module.exports = __webpack_public_path__ + "static/media/cubemap.19b1a8b8.png";